"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
const react_1 = __importDefault(require("react"));
//@ts-ignore
const query_string_1 = require("query-string");
const LayoutHandler_1 = require("@food/ui/build/dist/src/LayoutHandler");
const SocialLogin_1 = require("./SocialLogin");
const index_1 = require("../index");
const react_router_dom_1 = require("react-router-dom");
const Login = ({ t, container, onRedirect, authManager, config, tokens, }) => {
    const SocialLogin = react_1.default.useMemo(() => (0, SocialLogin_1.socialLoginFactory)(t), [t]);
    const Container = react_1.default.useMemo(() => container || (({ children }) => children), [container]);
    const location = (0, react_router_dom_1.useLocation)();
    const redirectUrl = (0, query_string_1.parse)(location.search).redirect || config.DEFAULT_LOGGED_ROUTE || '/';
    const params = (0, query_string_1.parse)(location.search);
    const { traditional, social, upgraderole } = params;
    if ((0, index_1.isLogged)() &&
        !upgraderole &&
        !tokens.workEmailVerifyToken &&
        !tokens.sfContactId) {
        onRedirect({}, redirectUrl);
        return null;
    }
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(LayoutHandler_1.LayoutHandler, { layouts: { main: SocialLogin_1.socialLoginLayoutChooser } }, (layouts) => (react_1.default.createElement(SocialLogin, { tokens: tokens, layout: layouts.main, isModal: false, authManager: authManager, logo: config.LOGO, config: config, startTraditional: (!!traditional || config.LOGIN_START_TRADITIONAL) &&
                !social, instantUpgradeRole: upgraderole })))));
};
exports.Login = Login;
//# sourceMappingURL=Login.js.map